import { useTranslation } from 'react-i18next';
import type { NoticeItem } from '@/hooks/useNotices';

const CATEGORY_ICON: Record<NoticeItem['category'], string> = {
  important: 'priority_high',
  general: 'info',
  hr: 'people',
  safety: 'health_and_safety',
};

interface NoticeCardProps {
  item: NoticeItem;
  onOpen?: () => void;
}

export function NoticeCard({ item, onOpen }: NoticeCardProps) {
  const { t } = useTranslation();

  return (
    <article
      className="notice-card"
      data-unread={item.unread || undefined}
      onClick={() => onOpen?.()}
      role="button"
    >
      <div className="notice-stripe" data-cat={item.category} />
      <div className="notice-body">
        <div className="notice-meta-top">
          <div className="notice-category" data-cat={item.category}>
            <span className="material-symbols-outlined">{CATEGORY_ICON[item.category]}</span>
            {t(`notices.cat_${item.category}`)}
          </div>
          {item.unread && <div className="notice-unread-dot" aria-label="unread" />}
        </div>

        <div className="notice-title">{item.title}</div>
        <div className="notice-preview">{item.body}</div>

        <div className="notice-footer">
          <div className="notice-author-avatar">{item.authorInitials}</div>
          <div className="notice-author">{item.authorName}</div>
          {item.attachmentCount > 0 && (
            <div className="notice-attach">
              <span className="material-symbols-outlined">attach_file</span>
              {item.attachmentCount}
            </div>
          )}
          <div className="notice-date">{item.date}</div>
        </div>
      </div>
    </article>
  );
}
